import React from 'react'
import styles from './styles.module.scss'
import Link from 'next/link'
import SvgArrowRight from '@/src/assets/svgs/collection/arrow-right.svg'
import { SvgBeanEater } from './svg-bean-eater'
import OrderGet from '@/src/interfaces/sales/order-get'
import { OrderStatusFunctions } from '@/src/app/pedido/acompanhar/[id]/functions'
import { DateHelper } from '@/src/helpers/date-helper'

interface Props {
    orderStatus: OrderGet.StatusResponse
}

export default function TrackOrderHeader({ orderStatus }: Props) {
    const lastStatus = orderStatus.statuses.at(-1)

    if (!lastStatus)
        return <></>

    return (
        <div className={styles.container}>
            <div className={styles.accompanyCard}>
                <div className={styles.topRow}>
                    <div className={styles.infoArea}>
                        <small>#{orderStatus.shortId}</small>
                        <h5 className='font-md'>{lastStatus.status === 'PlacedBySiteApp' ? 'Aguardando confirmação' : 'Pedido em andamento!'}</h5>
                        <span className={styles.description}>{DateHelper.time(lastStatus.updatedAt)} - {OrderStatusFunctions.getTranslatedStatus(lastStatus.status)}</span>
                    </div>
                    <div className={styles.imageArea}>
                        <SvgBeanEater />
                    </div>
                </div>
                <Link href={`/pedido/acompanhar/${orderStatus.id}`} className={styles.bottomRow}>
                    <span>Acompanhar</span>
                    <div className={styles.arrowImage}>
                        <SvgArrowRight />
                    </div>
                </Link>
            </div>
        </div>
    )
}
